import React from 'react';
import ListLive from './ListLive';
import BtnBecomingLiveScorer from './button/becominglivescorer/BtnBecomingLiveScorer';
import BtnPushingLiveScorePage from './button/pushinglive/BtnPushingLiveScorePage';
import { isSpectator, isLiveScorer, getOwnLive } from '../../../../../../helpers';
import PropTypes from 'prop-types';

const SectionLive = props => (
    <div className='ls_match_section_lives'>
        {!(props.page === 'upcomingMatch' && isLiveScorer(props.lives)) && <ListLive isSpectator={isSpectator(props.lives)} {...props} />}
        {props.page === 'upcomingMatch' && !isSpectator(props.lives)  && <ButtonAction {...props} />}
    </div>
)

const ButtonAction = props => isLiveScorer(props.lives) ? <BtnPushingLiveScorePage live={getOwnLive(props.lives)} date={props.date} /> : <BtnBecomingLiveScorer {...props} />

SectionLive.propTypes = {
    page: PropTypes.string.isRequired,
    lives: PropTypes.array.isRequired,
    date: PropTypes.string.isRequired
}

export default SectionLive;